import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router'
import { reducer as formReducer } from 'redux-form/immutable';
import addressbooks from '../addressbook/addressbooks';
import languages from './languages';
import locations from '../addressbook/locations';
import order from '../order/order';
import orders from '../orders/orders';
import products from '../order/products';
import regions from './regions';
import settings from '../settings/settings';
import certificate from '../certificate/certificate';
import services from './services';
import session from './session';
import spinner from './spinner';
import steps from '../order/steps';
import tenant from './tenant';
import tracking from '../orders/tracking';
import errors from './errors';
import tenants from './tenants';
import notifications from './notifications';
import additions from './additions';


export default (history) => combineReducers({
    router: connectRouter(history),
    addressbooks,
    form: formReducer,
    languages,
    locations,
    order,
    orders,
    products,
    regions,
    services,
    session,
    spinner,
    settings,
    certificate,
    steps,
    tracking,
    tenant,
    notifications,
    tenants,
    additions,
    errors,
});
